import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { BetRequest } from 'baseline-lib';
import { SharedService } from 'baseline-lib';
import { LottoBetpanelService } from 'baseline-lib';
import { SportBetPanelService } from 'baseline-lib';
import { gameType } from 'baseline-lib';
import { Notify } from 'baseline-lib';
import { BookBetService } from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';
import { LoadingController} from 'ionic-angular';



/**
 * Generated class for the CheckBetComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'check-bet',
  templateUrl: 'check-bet.html'
})
export class CheckBetComponent {

  tsnNo:string=null;
  _notify: Notify;

  constructor(
    public _sharedServices: SharedService,
    private _bookBetService : BookBetService,
    private _sportBetPanelService :SportBetPanelService ,
    private _lottoBetpanelService: LottoBetpanelService,
    public toast: CustomToast,
    public loadingCtrl: LoadingController,
    private route: ActivatedRoute,
     private _router: Router,
  
  ) {
    this._notify= new Notify();
   }

  ngOnInit() {
    this.tsnNo=null;
  }
  
   // to load booked bets via booking number
  loadCheckBookBet() 
  {
    this._bookBetService.checkBookBetTicket = new BetRequest();
    this._notify = new Notify()
    if (this.tsnNo == null || this.tsnNo.trim()=='') 
    {
      this.toast.showError("Enter Booking Number");
      return;
    }
    else
    {
      const loader = this.loadingCtrl.create({
        content: "Please Wait",
      });
        loader.present();
        
      let gametypeid: number = 0;
      // http call to load ticket data
      var betRequest = new BetRequest();
      betRequest.tn = this.tsnNo.trim();

      this._bookBetService._messageService.loadBookABet(betRequest)
        .subscribe(
        data => {
          loader.dismiss();
          this._bookBetService.checkBookBetTicket = data;
          this._bookBetService.checkBookBetTicket.tn = data.tktNo;
          this._notify.successMsg = "";

          this._notify = this._bookBetService._notify;
          this._sharedServices.hideLoader();
          if(this._bookBetService.checkBookBetTicket && this._bookBetService.checkBookBetTicket.tn)
          {
            if(this._sharedServices.selectedGameType)
                gametypeid = this._sharedServices.selectedGameType.gtid;

              if(gametypeid == 0 || gametypeid == undefined)
              {
              this.route.params.subscribe(params => 
                {
                  if (params['gametypeid'])
                  {
                      gametypeid = Number(params['gametypeid']);
                      this.processGameLoadForCheckBet(gametypeid);
                  }
                  });
              }
              else{
                this.processGameLoadForCheckBet(gametypeid);
              }
            }
            else{
              this._sportBetPanelService.clearallBetPanels();
              this._lottoBetpanelService.clearallBetPanels();
            }


        },
        error => {
          loader.dismiss();
          this._notify.error = true;
          this._sharedServices.hideLoader();
          if (error.msg) {
            this.toast.showError(error.msg);
          }
          else {
            this.toast.showError(error.message);
            this._bookBetService.mobileSharedService.errMessages = error.message;
          }
         
          this.forwardMsgToParent();
        });

    }
  }


  processGameLoadForCheckBet(_gametypeid)
  {
    this.tsnNo = null ;
    if (this._bookBetService.checkBookBetTicket)
    {
       // if game type is same load the betpanels
        if(_gametypeid == this._bookBetService.checkBookBetTicket.gt)
        {
          switch(Number(this._bookBetService.checkBookBetTicket.gt))
          {
            case gameType.sports :
              this._sportBetPanelService.processCheckBetsData(this._bookBetService.checkBookBetTicket);
            break;
      
            case gameType.lotto :
            this._lottoBetpanelService.processCheckBetsData(this._bookBetService.checkBookBetTicket);
            break;
      
          }
          this._bookBetService.checkBookBetTicket = undefined;
        }
        // if loaded game & booking game is different redirect to game
        else
        {
          this._sharedServices.hideLoader();
          this._router.navigate([this._bookBetService.checkBookBetTicket.gurl]);
        }
    }
  }

  forwardMsgToParent()
  {
    switch(this._sharedServices.selectedGameType.gtid)
    {
      case gameType.sports :
        this._sportBetPanelService.loadBookBetMsg.next(this._notify);
        break;
      case gameType.lotto :
          this._lottoBetpanelService.loadBookBetMsg.next(this._notify);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/check-bet/check-bet.ts